export const PL_KUP_SE_PROFIL_URL = 'https://profil-pracodawcy.olx.pl/#section-variants';
